<template>
  <br /><br />
  <section>
    <h3>
      <span class="gray">EQUIPOS DE </span>
      <span class="orange">ÚLTIMA TECNOLOGÍA</span>
    </h3>

    <header class="relative md:bg-center bg-cover pt-0 min-h-screen">
      <div class="relative w-full h-full">
        <!-- Imagen -->
        <img
          :src="currentSlide.image"
          alt="Imagen de equipo"
          class="w-full h-screen object-cover"
        />

        <!-- Texto sobre la imagen -->
        <div class="absolute inset-0 flex items-center">
          <div
            class="text-white bg-black bg-opacity-50 max-w-xl px-20 mt-auto mb-10"
          >
            <h2 class="text-4xl font-bold text-orange-400 mb-4 uppercase">
              {{ currentSlide.title }}
            </h2>
            <p class="text-justify text-lg leading-relaxed mb-4">
              {{ currentSlide.description }}
            </p>
            <!-- <button
                class="bg-white text-green-600 font-bold px-6 py-2 rounded shadow hover:bg-green-100 transition"
              >
                VER MÁS
              </button> -->
          </div>
        </div>

        <!-- Botones prev / next -->
        <button class="prev" @click="prev">&#10094;</button>
        <button class="next" @click="next">&#10095;</button>
      </div>
    </header>
  </section>
</template>

<script>
export default {
  name: "Slider",
  data() {
    return {
      slides: [
        {
          image: require("../assets/EquiposTecnologicos/tomografo.webp"),
          title: "TOMÓGRAFO",
          description:
            "Clínica La Sagrada Familia se consolida como una der las mejores en alta complejidad de la Región, gracias a su moderno Tomógrafo de 160 Cortes de última generación Canon Lightning Aquilion, el equipo de más alta categoría, lo que se traduce en alta precisión, seguridad y menor radiación para el paciente.",
        },
        {
          image: require("../assets/EquiposTecnologicos/resonador.webp"),
          title: "RESONADOR MAGNÉTICO",
          description:
            "Siemens Healthineers, equipo de resonancia magnética silencioso de 1.5 Teslas para estudios de cuerpo entero, ultrarrápido de alta resolución y sin radiación. Es el más avanzado de su tipo en el Eje Cafetero. ",
        },
        {
          image: require("../assets/EquiposTecnologicos/microscopio.webp"),
          title: "MICROSCOPIO QUIRÚRGICO",
          description:
            "Nuestro Microscopio Quirúrgico, de última generación. Permite realizar microcirugía en estructuras delicadas de Neurocirugía, Otorrinolaringología, Columna, Cirugía Plástica y Reconstructiva y Cirugía Maxilofacial.",
        },
        {
          image: require("../assets/EquiposTecnologicos/rayosX.webp"),
          title: "EQUIPO DE RAYOS X",
          description:
            "Técnica diagnóstica radiológica digital en base de datos cuya imagen se obtiene al exponer al receptor de imagen radiográfica a una fuente de radiación de alta energía.",
        },
        {
          image: require("../assets/EquiposTecnologicos/hemodinamia.webp"),
          title: "EQUIPO DE HEMODINAMIA",
          description:
            "Nuestra Moderna y amplia Unidad de Hemodinamia cuenta con el Angiografo Canon Alphenix, equipo de última tecnología para el diagnóstico y tratamiento de patologías cardiovasculares.",
        },
      ],
      currentIndex: 0,
      timer: null,
    };
  },
  computed: {
    currentSlide() {
      return this.slides[this.currentIndex % this.slides.length];
    },
  },
  mounted() {
    this.startSlide();
  },
  methods: {
    next() {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    },
    prev() {
      this.currentIndex =
        (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    },
    startSlide() {
      this.timer = setInterval(this.next, 5000); // Cambiado a 5 segundos
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
.prev,
.next {
  cursor: pointer;
  position: absolute;
  top: 50%;
  padding: 16px;
  color: white;
  font-weight: bold;
  font-size: 24px;
  background-color: rgba(0, 0, 0, 0.3);
  border: none;
  border-radius: 50%;
  transform: translateY(-50%);
  z-index: 10;
  transition: background-color 0.3s;
}
.prev:hover,
.next:hover {
  background-color: rgba(0, 0, 0, 0.6);
}
.prev {
  left: 20px;
}
.next {
  right: 20px;
}

h3 {
  font-size: 2.5rem;
  text-align: left;
  margin-left: 5%;
  margin-bottom: 0.5rem;
}
.orange {
  color: #ff6600;
  font-weight: bold;
}
.gray {
  color: #4a4a4a;
  font-weight: bold;
}
</style>
